.statusRow {
  display: flex;
  align-items: center;
  gap: var(--dixa-size-spacer-200);
  padding: var(--dixa-size-spacer-200) 0;
  color: var(--dixa-typography-color-secondary);
}

// Matches the default 16px Icon size, so every row's label starts at the same x.
.iconSlot {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
}
